/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownAcademicAssessmentStatus } from '../models/db_DropdownAcademicAssessmentStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AcademicAssessmentStatuses {
    /**
     * Get a list of academic assessment statuses
     * @returns db_DropdownAcademicAssessmentStatus OK
     * @throws ApiError
     */
    public static listAcademicAssessmentStatuses(): CancelablePromise<Array<db_DropdownAcademicAssessmentStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/academic-assessment-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
